import React from "react";

import { LayoutLogin } from "../../_templates/auth/LayoutLogin";

export function Login() {
  return <LayoutLogin />;
}
